
    import {defineComponent, toRefs, reactive} from "vue";
    import common from "@/util/common.ts";

    interface State {
        showProtect: boolean;
    }
    export default defineComponent({
        name: "detectMan",
        components: {
        },
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                showProtect: false
            })
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
            return {
                state,
                getData
            }
        }
    })
